var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1245_14300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33337 5.33398V3.46732C5.33337 2.72058 5.33337 2.34721 5.4787 2.062C5.60653 1.81111 5.8105 1.60714 6.06139 1.47931C6.3466 1.33398 6.71997 1.33398 7.46671 1.33398H12.5334C13.2801 1.33398 13.6535 1.33398 13.9387 1.47931C14.1896 1.60714 14.3936 1.81111 14.5214 2.062C14.6667 2.34721 14.6667 2.72058 14.6667 3.46732V8.53398C14.6667 9.28072 14.6667 9.65409 14.5214 9.93931C14.3936 10.1902 14.1896 10.3942 13.9387 10.522C13.6535 10.6673 13.2801 10.6673 12.5334 10.6673H10.6667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33337 7.46732C1.33337 6.72058 1.33337 6.34721 1.4787 6.062C1.60653 5.81111 1.8105 5.60714 2.06139 5.47931C2.3466 5.33398 2.71997 5.33398 3.46671 5.33398H8.53337C9.28011 5.33398 9.65348 5.33398 9.93869 5.47931C10.1896 5.60714 10.3936 5.81111 10.5214 6.062C10.6667 6.34721 10.6667 6.72058 10.6667 7.46732V12.534C10.6667 13.2807 10.6667 13.6541 10.5214 13.9393C10.3936 14.1902 10.1896 14.3942 9.93869 14.522C9.65348 14.6673 9.28011 14.6673 8.53337 14.6673H3.46671C2.71997 14.6673 2.3466 14.6673 2.06139 14.522C1.8105 14.3942 1.60653 14.1902 1.4787 13.9393C1.33337 13.6541 1.33337 13.2807 1.33337 12.534V7.46732Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1245_14300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.f4d500610fd8759e51fedf44760c6f1d.svg";
export { ForwardRef as ReactComponent };